'use client';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Show } from '@chakra-ui/react';
import cn from 'classnames';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import React, { useEffect, useRef } from 'react';

import Styles from './Nav.module.scss';

const ExperienceKiaHeader = () => {
  const navRef = useRef<HTMLDivElement>(null);
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const activeLink = document.querySelector(
      `.${Styles.menuLinkActive}`,
    ) as HTMLAnchorElement;
    const nav = navRef.current;

    if (activeLink && nav) {
      const linkRect = activeLink.getBoundingClientRect();
      const navRect = nav.getBoundingClientRect();

      const linkCenter = linkRect.left + linkRect.width / 2;
      const navCenter = navRect.left + navRect.width / 2;

      nav.scrollLeft += linkCenter - navCenter;
    }
  }, [pathname]);

  return (
    <nav className={cn(Styles.blogNavBar, pathname == '/blog')}>
      <Box className={Styles.mainNav}>
        <Flex
          className={Styles.flexWrapper}
          maxW={1328}
          width={'100%'}
          marginX={'auto'}
          paddingLeft={{ base: 6, '2xl': 0 }}
          paddingRight={{ base: 0, lg: '10%' }}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Button
            onClick={() => router.push('/blog')}
            className={Styles.backBtn}
            padding={0}
            role="button"
            marginRight={6}
          >
            <ChevronLeftIcon role="button" />
            <Show above="md">
              <Box className={Styles.backBtnText} role="button">
                Experience Kia
              </Box>
            </Show>
            <Show below="md">
              <Box className={Styles.backBtnText} role="button">
                Back
              </Box>
            </Show>
          </Button>

          <Box className={Styles.KiaOneNavigation} ref={navRef}>
            <ul>
              <li className={Styles.menuItem}>
                <Link
                  className={cn(
                    Styles.menuLink,
                    pathname == '/blog/latest-news' && Styles.menuLinkActive,
                  )}
                  href="/blog/latest-news"
                  passHref
                >
                  Latest News
                </Link>
              </li>
              <li className={Styles.menuItem}>
                <Link
                  className={cn(
                    Styles.menuLink,
                    pathname == '/blog/car-reviews' && Styles.menuLinkActive,
                  )}
                  href="/blog/car-reviews"
                  passHref
                >
                  Car Reviews
                </Link>
              </li>
              {/* <li className={Styles.menuItem}>
                <Link
                  className={cn(
                    Styles.menuLink,
                    pathname == '/blog/social-media' && Styles.menuLinkActive,
                  )}
                  href="/blog/social-media"
                  passHref
                >
                  Social Media
                </Link>
              </li> */}

              <li className={Styles.menuItem}>
                <Link
                  className={cn(
                    Styles.menuLink,
                    pathname == '/blog/buying-used-cars' &&
                      Styles.menuLinkActive,
                  )}
                  href="/blog/buying-used-cars"
                  passHref
                >
                  Buying Used Cars
                </Link>
              </li>

              <li className={Styles.menuItem}>
                <Link
                  className={cn(
                    Styles.menuLink,
                    pathname == '/blog/car-launches' && Styles.menuLinkActive,
                  )}
                  href="/blog/car-launches"
                  passHref
                >
                  Car Launches
                </Link>
              </li>

              <li className={Styles.menuItem}>
                <Link
                  className={cn(
                    Styles.menuLink,
                    pathname == '/blog/consumer-advice' &&
                      Styles.menuLinkActive,
                  )}
                  href="/blog/consumer-advice"
                  passHref
                >
                  Consumer Advice
                </Link>
              </li>
            </ul>
          </Box>
          <Box w={{ base: '0', md: '55px' }} />
        </Flex>
      </Box>
    </nav>
  );
};

export default ExperienceKiaHeader;
